import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminProgressReviewMemoRequest } from '../../contracts/review/AdminProgressReviewMemoRequest'

export const getAdminProgressReviewMemoRequest = asBuilder((): AdminProgressReviewMemoRequest => {
  return {
    reviewId: faker.number.int(),
    memo: faker.lorem.sentence(),
    rewardType: 'COMPLETED_PROGRESSES_WITH_MINIMUM_COUNTS',
  }
})
